import { VideoEmailEmbedType } from '@core/api/types/api_video';
import { useContextTranslation } from '@core/i18n';
import { Heading, RadioButton, RadioButtonWrapper, RadioGroup, RadioLabel, } from '../EmailEmbedModal.styles';
import { TypeSelectionWrapper } from './EmailEmbedTypeSection.styles';
const ANIMATED_BUTTON_ID = 'videoTypeRadioButtonAnimated';
const ANIMATED_LABEL_ID = 'videoTypeRadioButtonAnimatedLabel';
const STATIC_BUTTON_ID = 'videoTypeRadioButtonStatic';
const STATIC_LABEL_ID = 'videoTypeRadioButtonStaticLabel';
/**
 *
 */
export const EmailEmbedTypeSection = ({ onEmbedTypeChange, }) => {
    const { t } = useContextTranslation();
    return (<TypeSelectionWrapper>
      <Heading marginBottom={11}>{t('player:Type')}</Heading>
      <RadioGroup>
        <RadioButtonWrapper>
          <RadioButton defaultChecked id={ANIMATED_BUTTON_ID} aria-labelledby={ANIMATED_LABEL_ID} type="radio" name="videoType" value={VideoEmailEmbedType.ANIMATED} onChange={onEmbedTypeChange}/>
          <RadioLabel htmlFor={ANIMATED_BUTTON_ID} id={ANIMATED_LABEL_ID}>
            {t('player:Animated')}
          </RadioLabel>
        </RadioButtonWrapper>
        <RadioButtonWrapper>
          <RadioButton id={STATIC_BUTTON_ID} aria-labelledby={STATIC_LABEL_ID} type="radio" name="videoType" value={VideoEmailEmbedType.STATIC} onChange={onEmbedTypeChange}/>
          <RadioLabel htmlFor={STATIC_BUTTON_ID} id={STATIC_LABEL_ID}>
            {t('player:Static')}
          </RadioLabel>
        </RadioButtonWrapper>
      </RadioGroup>
    </TypeSelectionWrapper>);
};
